import { render, staticRenderFns } from "./modeli-vozila.editor.vue?vue&type=template&id=03e16b40&scoped=true&"
import script from "./modeli-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./modeli-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e16b40",
  null
  
)

export default component.exports